import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import DegreeAndDepartmentFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/DegreeAndDepartmentFilter'
import {
  MenuFlex,
  StyledTabNew,
  SubmitFlex,
} from 'modules/Users/Partials/UsersFilter/Styles/style'
import React, { useState } from 'react'
import CandidateRatingFilter from '../../../../../ApplicantTrackingSystem/ApplicationTable/Partials/CandidateRating'
import YearsOfExpFilter from '../../../../../ApplicantTrackingSystem/ApplicationTable/Partials/Years0fExperienceFilter'
import CollegeNameFilter from '../CollegeFilter'
import LastestCompanyFilter from '../LastestCompanyFilter'
import LastestRoleFilter from '../LastestRoleFilter'
import LocationFilterQuest from '../LocationFilter'
const QuestionnierFilter = ({
  searchValue,
  questionnaireData,
  singleRoleData,
  setSearchValue,
  questionaireDBList,
  candidateFilterData,
  setCandidateFilterData,
  setFilterStatus,
  candidateRating,
  setCandidateRating,
  yearOfExperience,
  setYearOfExperience,
  checkedKeys,
  setCheckedKeys,
  checkedIds,
  setCheckedIds,
  qbBasedCollegeList,
  rolesDegreeList,
  setCollege,
  college,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [filteredData, setFilteredData] = useState({})
  const [filteredDataEx, setFilteredDataEx] = useState({})
  // const [college, setCollege] = useState('')
  const [location, setLocation] = useState()
  const [locationValue, setLocationValue] = useState([])
  const [locationSearch, setLocationSearch] = useState('')
  const [locationValueNew, setLocationValueNew] = useState([])
  const [locationSearchNew, setLocationSearchNew] = useState('')

  const submitFilter = () => {
    setIsMenuOpen(false)
    setFilterStatus(filteredData?.status)

    setFilteredData({
      ...filteredData,
      rating: candidateRating,
      degree: checkedIds,
      degreeKeys: checkedKeys,
      instituteCampusIds: college,
    })
    setCandidateFilterData({
      rating: candidateRating || '',
      degreeDepartment: checkedIds || [],
      degreekeys: checkedKeys,
      instituteCampusIds: college || '',
    })
  }

  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)

    if (!open) {
      setCandidateRating(candidateFilterData?.rating)
      setCheckedIds(candidateFilterData?.degreeDepartment)
      setCheckedKeys(candidateFilterData?.degreekeys)
      setCollege(candidateFilterData?.instituteCampusIds)
    }
  }

  const submitFilterEx = () => {
    setIsMenuOpen(false)
    setFilterStatus(filteredDataEx?.status)

    setFilteredDataEx({
      ...filteredDataEx,
      rating: candidateRating,
      yearOfEx: yearOfExperience,
      location: location,
      latestCompany: locationValue,
      latestRole: locationValueNew,
    })
    setCandidateFilterData({
      rating: candidateRating || '',
      yearOfEx: yearOfExperience || '',
      location: location,
      latestCompany: locationValue,
      latestRole: locationValueNew,
    })
  }

  const onCancelExFilter = open => {
    setIsMenuOpen(!isMenuOpen)

    if (!open) {
      setCandidateRating(candidateFilterData?.rating)
      setLocation(candidateFilterData?.location)
      setLocationValue(candidateFilterData?.latestCompany)
      setLocationValueNew(candidateFilterData?.latestRole)
      setYearOfExperience(candidateFilterData?.yearOfEx)
    }
  }
  const menu = (
    <MenuFlex column>
      {singleRoleData?.jobTypeLevels?.[0] != 'EXPERIENCED' && (
        <StyledTabNew
          border={true}
          tabPosition={'left'}
          type="card"
          padding="15px"
          items={[
            // {
            //   label: 'Candidate Rating',
            //   key: '1',
            //   children: (
            //     <div style={{ width: '100%', overflow: 'hidden' }}>
            //       <CandidateRatingFilter
            //         candidateRating={candidateRating}
            //         setCandidateRating={setCandidateRating}
            //       />
            //     </div>
            //   ),
            // },
            {
              label: 'Degree & Department',
              key: '2',
              children: (
                <DegreeAndDepartmentFilter
                  degreeListData={rolesDegreeList}
                  checkedKeys={checkedKeys}
                  setCheckedKeys={setCheckedKeys}
                  checkedIds={checkedIds}
                  setCheckedIds={setCheckedIds}
                />
              ),
            },
            {
              label: 'College Name',
              key: '3',
              children: (
                <CollegeNameFilter
                  collegeList={qbBasedCollegeList}
                  college={college}
                  setCollege={setCollege}
                />
              ),
            },
          ]}
        />
      )}
      {singleRoleData?.jobTypeLevels?.[0] == 'EXPERIENCED' && (
        <StyledTabNew
          border={true}
          tabPosition={'left'}
          type="card"
          padding="15px"
          items={[
            {
              label: 'Latest Company',
              key: '1',
              children: (
                <LastestCompanyFilter
                  locationValue={locationValue}
                  setLocationValue={setLocationValue}
                  atsBasedLocationList={questionnaireData?.latestCompany || []}
                  setLocationSearch={setLocationSearch}
                  locationSearch={locationSearch}
                />
              ),
            },
            {
              label: 'Latest Role',
              key: '2',
              children: (
                <LastestRoleFilter
                  locationValue={locationValueNew}
                  setLocationValue={setLocationValueNew}
                  atsBasedLocationList={questionnaireData?.latestRole || []}
                  setLocationSearch={setLocationSearchNew}
                  locationSearch={locationSearchNew}
                />
              ),
            },
            {
              label: 'Location',
              key: '3',
              children: (
                <LocationFilterQuest
                  collegeList={questionnaireData?.location}
                  college={location}
                  setCollege={setLocation}
                />
              ),
            },
            {
              label: 'Years Of Experience',
              key: '4',
              children: (
                <YearsOfExpFilter
                  maxWorkExperience={questionnaireData?.maxWorkExperience}
                  candidateRating={yearOfExperience}
                  setCandidateRating={setYearOfExperience}
                />
              ),
            },
            {
              label: 'Candidate Rating',
              key: '5',
              children: (
                <CandidateRatingFilter
                  candidateRating={candidateRating}
                  setCandidateRating={setCandidateRating}
                />
              ),
            },
          ]}
        />
      )}
      {singleRoleData?.jobTypeLevels?.[0] != 'EXPERIENCED' && (
        <SubmitFlex right>
          <Button.Secondary
            text="Cancel"
            onClick={() => onCancelFilter(false)}
          />
          <Button.Primary text="Apply Filter" onClick={submitFilter} />
        </SubmitFlex>
      )}
      {singleRoleData?.jobTypeLevels?.[0] == 'EXPERIENCED' && (
        <SubmitFlex right>
          <Button.Secondary
            text="Cancel"
            onClick={() => onCancelExFilter(false)}
          />
          <Button.Primary text="Apply Filter" onClick={submitFilterEx} />
        </SubmitFlex>
      )}
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      currentCount={
        questionaireDBList?.count < 10
          ? questionaireDBList?.count
          : questionaireDBList?.result?.length + questionaireDBList?.page * 10
      }
      totalCount={questionaireDBList?.count}
      onOpenChange={onCancelFilter}
    />
  )
}

export default QuestionnierFilter
